<template>
  <div class="my-10">
    <div class="flex justify-center px-4 items-center">
      <h1 class="text-3xl font-bold text-center">{{ __('Edit job :id', {number: job.id}) }}</h1>
    </div>

    <div class="bg-white p-4 shadow-md mt-10">
      <div class="flex flex-wrap sm:flex-nowrap -mx-2">
        <div class="m-2 bg-gray-300 rounded-lg w-full sm:w-1/2 p-4 flex flex-col items-center py-5">
          <div class="mt-2 text-xl font-bold text-center">
            <p class="font-normal text-gray-400">{{ job.car.car_make.name }} {{ job.car.model }}</p>
            <p class="mt-4">{{ job.car.registration_number }}</p>
            <p class="mt-4 font-normal text-gray-400" v-if="false">{{job.car.vin}}</p>
          </div>
        </div>

        <div class="m-2 bg-gray-300 rounded-lg w-full sm:w-1/2 p-4 flex flex-col items-center justify-center py-5">
          <div class="text-xl">{{ __("Client") }}</div>
          <div class="mt-2 text-xl font-bold">{{ job.client.name }}</div>
        </div>
      </div>

      <div class="my-2 bg-gray-300 rounded-lg p-4 flex flex-col items-center py-5">
        <div class="text-xl">{{ __("Status") }}</div>
        <div class="mt-2 text-xl font-bold job-status" :class="job.status">{{ job.status_label }}</div>
      </div>
    </div>

    <job-medialibrary :job="job" :editable="false"></job-medialibrary>


    <div class="bg-white px-5 py-10 shadow-md mt-10">
      <h2 class="text-3xl text-center">{{ __("Description") }}</h2>
      <div class="mt-12 text-xl leading-normal max-w-4xl mx-auto">
        {{ job.description }}
      </div>
    </div>

    <div class="bg-white px-5 py-10 shadow-md mt-10">
      <h2 class="text-3xl text-center">{{ __("Observations") }}</h2>
      <div class="mt-12 text-xl leading-normal max-w-4xl mx-auto">
        {{ job.observations || __('No observations just yet..')}}
      </div>
    </div>
  </div>
</template>

<script>
  import ClientJobLayout from '@/Shared/ClientJobLayout';
  import JobMedialibrary from './JobMedialibrary';
  import Nprogress from 'nprogress'

  export default {
    layout: ClientJobLayout,
    metaInfo() {
      return {
        title: this.__("Jobs")
      }
    },
    props: {
      job: Object,
    },
    components: {
      ClientJobLayout,
      JobMedialibrary,
    },
    mounted() {
      window.Echo.channel('App.Models.Job.' + this.job.id)
        .listen('JobFilesAddedEvent', (data) => this.handleJobWasUpdated(data))
        .listen('JobUpdatedEvent', (data) => this.handleJobWasUpdated(data));
    },
    destroyed() {
      window.Echo.channel('App.Models.Job.' + this.job.id)
        .stopListening('JobFilesAddedEvent')
        .stopListening('JobUpdatedEvent');
    },
    methods: {
      handleJobWasUpdated() {
        if (!Nprogress.isStarted()) {
          this.$inertia.reload({preserveScroll: true, preserveState: true});
        }
      },
    },
    computed: {
      jobComplete() {
        return this.job.status === 'completed';
      }
    }
  }
</script>
